<template>
  <div class="form-group">
    <label for="" class="control-label">Task Name:</label><br />
    <Dropdown
      class="AuditMultiSelect"
      inputStyle="z-index:2000"
      v-model="SelectedTasks"
      :options="Tasks"
      :editable="true"
      v-on:input="set"
      optionLabel="taskName"
      placeholder="Search By Task Name"
    />
  </div>

  <div class="form-group">
    <label for="" class="control-label">Due Date:</label>
    <input
      v-model="DueDate"
      type="date"
      class="form-control"
      placeholder="Add Due Date"
    />
  </div>

  <div class="form-group">
    <label for="" class="control-label">Assign To:</label><br />
    <MultiSelect
      :filter="true"
      class="AuditMultiSelect"
      inputStyle="z-index:2000"
      v-model="SelectedUsers"
      :options="Users"
      optionValue="userId"
      optionLabel="name"
      placeholder="Search By Users"
      display="chip"
      multi
    />
  </div>

  <div class="form-group">
    <label for="" class="control-label">Status:</label><br />
    <!-- <Dropdown class="AuditMultiSelect" @change="ChangeTaskStatus()" display="chip" v-model="SelectedTasksStatus" :options="TasksStatus"
            optionLabel="name" placeholder="Search By Task Status" /> -->
    <Dropdown
      class="AuditMultiSelect"
      display="chip"
      v-model="SelectedTasksStatus"
      :options="TasksStatus"
      optionLabel="name"
      optionGroupLabel="labelName"
      optionGroupChildren="tasksStatuses"
      placeholder="Search By Task Status"
      @change="ChangeTaskStatus()"
    />
  </div>
  <div class="row mb-4">
    <button
      type="button"
      @click="AddCheckinTask()"
      class="btn btn-outline-success waves-effect waves-light col-12 addedtask"
    >
      Add Task
    </button>
  </div>

  <Dialog
    :autoZIndex="true"
    :draggable="false"
    v-model:visible="AddTaskStatusModal"
    :modal="true"
    appendTo="body"
    style="width: 30%; max-height: max-content"
  >
    <template #header>
      <h4 class="modal-title" id="myModalLabel">Add A Status</h4>
    </template>
    <div class="modal-body mb-1 pt-2" id="mydiv">
      <TaskStatusAddComponent
        :changeTaskStatus="getTableFilters"
        :closeModal="closeTaskStatus"
      ></TaskStatusAddComponent>
    </div>
  </Dialog>
</template>
<script>
// import localMixin from "./Mixins/DailyReport";
import axios from "axios";
import moment from "moment";
import TaskStatusAddComponent from "./TaskStatusAddComponent.vue";
export default {
  name: "TaskAddTocomponent",
  props: ["tableCall", "visitIdProp", "closeModal", "patientId"],
  components: {
    TaskStatusAddComponent,
    // Multiselect,
  },

  data() {
    return {
      AddTaskStatusModal: false,
      visitId: 0,
      showModal: false,
      Tasks: [],
      Users: [],
      TasksStatus: [],
      SelectedUsers: null,
      SelectedTasks: null,
      SelectedTasksStatus: null,
      PatientId: null,
    };
  }, // data

  methods: {
    ChangeTaskStatus() {
      debugger;
      if (this.SelectedTasksStatus.id == 0) this.AddTaskStatusModal = true;
    },
    closeTaskStatus() {
      this.AddTaskStatusModal = false;
    },
    showAddModal() {
      this.showModal = true;
    },
    hideModal() {
      this.showModal = false;
    },
    async getTableFilters(visitId) {
      (this.SelectedUsers = null),
        (this.SelectedTasks = null),
        (this.SelectedTasksStatus = null),
        (this.visitId = visitId);

      this.intDummyComm();
      var loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.tableLoad,
        color: "#03a9f3",
      });
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/GetTasksDetailToAddAll",
        data: this.dummyComm,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data.data;
          this.TasksStatus = myData.taskStatusGroup; // myData.taskStatus;

          var firstTask = { id: 0, name: "Add Status +" };
          debugger;
          console.log(myData.allTasks);
          this.TasksStatus[0].tasksStatuses.splice(0, 0, firstTask);
          // this.TasksStatus.splice(0, 0, firstTask);
          this.SelectedTasksStatus = this.TasksStatus[0].tasksStatuses[1];
          this.Tasks = myData.allTasks;
          this.Users = myData.userTaskLists;
        })
        .finally(() => {
          loader.hide();
        });
    },
    async AddCheckinTask() {
      this.intDummyComm();
      var taskName = "";
      if (this.DueDate == null) {
        this.ShowWarning("Due Date is require");
        event.preventDefault();
        return;
      }
      if (this.SelectedTasksStatus == null) {
        this.ShowWarning("Task Status is require");
        event.preventDefault();
        return;
      }

      if (this.SelectedTasks.taskName == undefined) {
        taskName = this.SelectedTasks;
      } else {
        taskName = this.SelectedTasks.taskName;
      }
      if (taskName == "") {
        this.ShowWarning("Task Name is require");
        event.preventDefault();
        return;
      }
      debugger;

      this.dummyComm.patientId = this.patientId;

      var obj = {
        DC: this.dummyComm,
        TaskName: taskName,
        TaskId: this.SelectedTasks.taskID,
        DueDate: this.DueDate,
        AssignToIds: this.SelectedUsers,
        TaskStatusId: this.SelectedTasksStatus.id,
        visitId: this.visitId,
      };
      this.intDummyComm();
      var loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.tableLoad,
        color: "#03a9f3",
      });
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/AddCheckInTask",
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data.data;
          if (myData.status == true) {
            this.successToast();
            this.closeModal();
          } else {
            this.errorToast("Unable to update information");
          }
          {
            console.log(myData);
          }
        })
        .finally(() => {
          this.showModal = false;
          loader.hide();
          this.closeModal();
          this.tableCall();
        });
    },
  },
  computed: {}, // computed

  watch: {}, //watch

  mounted() {
    this.DueDate = new Date().toISOString().substr(0, 10);
    this.getTableFilters();
    this.visitId = this.visitIdProp;
  }, // mounted
};
</script>
<style scoped>
.AuditMultiSelect {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  /* border-bottom: 2px solid rgb(240, 141, 11); */
  border-bottom: 1px solid rgb(235, 235, 235);
  box-shadow: none;
  width: 100%;
  z-index: 2000px;
}

#font1 {
  font-weight: bold;
}

.asc-desc-btn {
  background-color: transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  outline: none;
  color: honeydew;
  float: right;
}

.colorActive {
  color: #f95c2e;
}

.activeColor {
  background-color: #fb9678;
  color: white;
}

.action_icon {
  height: 20px;
}

.trans-input {
  color: #000000b8;
  text-align: center;
  background: transparent;
  border: none;
}
</style>
